/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Write_Long_ContentInputs */



/**
* | output |
* | --- |
* | "Write and edit longer content" |
*
* @param {Onboarding_Usage_Write_Long_ContentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_write_long_content = /** @type {((inputs?: Onboarding_Usage_Write_Long_ContentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Write_Long_ContentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Längere Inhalte schreiben und bearbeiten")
	return /** @type {LocalizedString} */ ("Write and edit longer content")
});